import { Dialog, styled } from "@mui/material";


export const DatePickerModal = styled(Dialog)({
    '& .MuiDialog-paper': {
        borderRadius: '16px'
    }
})